import axios from "axios";
import HERU_API from "../constants/heruApi";

export const getInvoicingCatalog = async () => {
  try {
    const response = await axios.get(HERU_API.INVOICE_CATALOGS);
    return response.data;
  } catch (error) {
    throw error;
  }
};
